var React = require('react');

function ArrowRightSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34,987.655a.891.891,0,0,0-.215-.546l-4.235-4.5a.909.909,0,0,0-1.158-.066A.827.827,0,0,0,28.4,983.7l2.978,3.16H16.794a.794.794,0,0,0,0,1.588H31.378l-2.978,3.16a.875.875,0,0,0-.008,1.158.9.9,0,0,0,1.158-.066l4.235-4.5A.764.764,0,0,0,34,987.655Z","transform":"translate(-16 -982.362)","fill":"currentColor"}));
}

ArrowRightSolid.defaultProps = {"width":"18","height":"10.588","viewBox":"0 0 18 10.588"};

module.exports = ArrowRightSolid;

ArrowRightSolid.default = ArrowRightSolid;
